import { Directive, Input, ContentChildren, QueryList, OnInit, forwardRef } from '@angular/core';

@Directive({
    selector: 'nova-menu-item',
    standalone: true
})
export class MenuItemDirective implements OnInit {
    @Input() name = '';
    @Input() path: string;
    @Input() queryParams: any;
    @Input() title: string;
    @Input() icon: string;
    @Input() defaultItem: string;
    @Input() cssClass: string;
    @Input() dataCy: string;
    @Input() dealAlert: number;
    @Input() showDealAlert: boolean;

    @ContentChildren(forwardRef(() => MenuItemDirective)) private items: QueryList<MenuItemDirective>;

    url = '';
    isVisible = false;

    //@ContentChildren() includes the host element; this is a known bug:  https://github.com/angular/angular/issues/10098
    get subItems(): MenuItemDirective[] {
        return this.items.filter((item) => item !== this);
    }

    ngOnInit(): void {
        this.path = this.path || this.name;
    }
}
